import React, {useEffect} from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {setSwitcherPosition, toggleShowManualCalculation} from "../../../../../actions/sqftManualCalculationFunctions";
import PropTypes from "prop-types";

const ManualCalculateSwitcher = (props) => {
  const {overlay, setSwitcherPosition, switcherPosition, showManualCalculation, toggleShowManualCalculation, isMobile,
    sideBarButtons} = props;

  const handleButtonClick = () => {
    // changeStateToQuote();
    toggleShowManualCalculation(!showManualCalculation);
  };

  useEffect(() => {
    if (!overlay) {
      const elem = document.getElementById("manual-switcher");
      const rect = elem.getBoundingClientRect();
      setSwitcherPosition({rect})
    }
  }, [overlay, sideBarButtons, setSwitcherPosition]);

  const blockStyle = {
    left: overlay ? switcherPosition.rect.left : ''
  }
  isMobile
    ? blockStyle.bottom = overlay ? '13px' : ''
    : blockStyle.top = overlay ? switcherPosition.rect.top : ''

  return (
    <div className="ui-radio-block"
         id={overlay ? "manual-overlay-switcher" : "manual-switcher" }
         style={blockStyle}
    >
      <span className="ui-radio-label ui-radio-label--blue ui-radio-label--small">
        <FormattedMessage id="sqft.navigation.menu.manualMode"/>
      </span>
      <button className={"ui-radio ui-radio--small" + (showManualCalculation ? " ui-radio--checked" : "")}
              onClick={handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

ManualCalculateSwitcher.propTypes = {
  overlay: PropTypes.bool,
  sideBarButtons: PropTypes.array,
};

const mapStateToProps = (store) => ({
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
  switcherPosition: store.sqftManualCalculationState.switcherPosition,
  isMobile: store.serverState.isMobile,
});

const mapDispatchToProps = {
  toggleShowManualCalculation,
  setSwitcherPosition,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManualCalculateSwitcher);
